// Cuánto lugar ocupa el menú principal: nombres completos, texto reducido o sólo íconos (los íconos van siempre).
// Cómo se ve cada una lo define `.zaf-rail[data-density]` en index.css.
export const DENSITIES = ['full', 'compact', 'icons'];

// Prueba de más a menos y deja la primera en la que las secciones entran sin desplazarse.
export const fitNavDensity = (nav) => {
    for (const density of DENSITIES) {
        nav.dataset.density = density;
        if (nav.scrollWidth <= nav.clientWidth) break;
    }
    return nav.dataset.density;
};
